import { FeatureCollection, Point } from 'geojson';
import { Observable } from 'rxjs';

export type FluentCrs = {
  'crs': {
    /**
     * @example 'name'
     */
    'type': string
    'properties': {
      /**
       * @example 'urn:ogc:def:crs:OGC:1.3:CRS84'
       */
      'name': string
    }
  }
};

/**
 * See rego-cdk lib/functions/fluent.ts
 */
export type FluentFeatureConfidentialProperties = {
  'carname': string
  'drivername': string
};

export type FluentFeatureBaseProperties = {
  'carid': string
  'cartype': string
  'createdon': string
  'speed': string
  'course': string
  'streetaddress': string
  'accuracy': string
  'contractid': string
  'contractname': string
  'operationname': string
};

/**
 * All properties seem to be present, although string values can be empty
 * 'course' values range from 0 -> 360, where:  0 = north, 90 = east, 180 = south, 240 = west
 * @example
{
  "accuracy": "",
  "carid": "123",
  "carname": "Toyota Prius ABC - 123",
  "cartype": "Kuorma-auto",
  "contractid": "56",
  "contractname": "Joensuun Vesi",
  "course": "115.52",
  "createdon": "2021-04-28 15:16:44",
  "drivername": "Erkki Esimerkki",
  "operationname": "Ajossa"
  "speed": "1.2861111",
  "streetaddress": "pajakatu 4 Joensuu",
}
 */
export type FluentFeatureAllProperties = FluentFeatureBaseProperties & FluentFeatureConfidentialProperties;

export type FluentBaseResult = FeatureCollection<Point, FluentFeatureBaseProperties> & FluentCrs;
export type FluentWebsocketResult = FeatureCollection<Point, FluentFeatureAllProperties> & FluentCrs;
export type FluentRestGetFeatureResult = FeatureCollection<Point, FluentFeatureAllProperties> & {
  /**
   * should equal to one when filtering by carid only
   */
  numberMatched: number
};


export type IsLayerVisibleCb = () => boolean;
export abstract class FluentDatasource {
  data$: Observable<FluentBaseResult>;
  abstract init(isLayerVisibleCb: IsLayerVisibleCb);
  abstract subscribe(): void;
  abstract unsubscribe(): void;

}
